import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Pipe({
  name: 'objectEntries'
})
export class ObjectEntriesPipe implements PipeTransform {
  transform(param: any): any {
    return param ?  _.map(param, (value, key) => ({ key, value })) : [];
  }
}
